import { z } from 'zod';

const clinicDetailsSchema = z.object({
   address_1: z.string().trim().min(1, 'Address 1 is required'),
   address_2: z.string(),
   post_code: z
      .string()
      .trim()
      .min(1, 'Post code is required')
      .max(10, 'Post code must be at most 10 characters')
      .regex(/^[a-zA-Z0-9 ]+$/, 'Invalid post code'),
   phone_number: z.string().trim().min(1, 'Phone number is required'),
   nationality: z.string().trim().min(1, 'Residence is required'),
   state: z.string().trim().min(1, 'Town is required'),
   city: z.string().trim().min(1, 'City is required'),
});

export type TClinicDetails = z.infer<typeof clinicDetailsSchema>;
export { clinicDetailsSchema };
